import { PortableText } from '@portabletext/react'
import type { InferGetServerSidePropsType, GetServerSideProps } from 'next'
import { useLiveQuery } from '~/lib/sanity-live-query'
import { getGlobalData } from '../utils/global-data';
import Footer from '../components/Footer';
import Layout from '../components/Layout';
import SEO from '../components/SEO';
import StickyNavbar from '../components/StickyNavbar';
import ModuleList from '../components/ModuleList';

import { readToken } from '~/lib/sanity.api'
import { getClient } from '~/lib/sanity.client'
import {
  getPage,
  getSiteConfig,
  pageBySlugQuery,
  siteConfigQuery,
} from '~/lib/sanity.queries'
import { type Page, SiteConfig} from '~/lib/sanity.interfaces'
import type { SharedPageProps } from '~/pages/_app'



  interface Query {
    [key: string]: string
  }
  
  export const getServerSideProps: GetServerSideProps<
    SharedPageProps & {
      page: Page,
      siteConfig: SiteConfig,
    },
    Query
  > = async ({ draftMode = false, params = {} }) => {
    const client = getClient(draftMode ? { token: readToken } : undefined)
    const page = await getPage(client, params.slug)
    const siteConfig = await getSiteConfig(client)
    const globalData = getGlobalData()
  
    if (!page) {
      return {
        notFound: true,
      }
    }
  
    return {
      props: {
        globalData,
        draftMode,
        token: draftMode ? readToken : '',
        page,
        siteConfig,
      },
    }
  }

  

export default function CategoryPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
  globalData
) {
  const [page] = useLiveQuery(props.draftMode, props.page, pageBySlugQuery, {
    slug: props.page.slug.current,
  })
  const [siteConfig] = useLiveQuery(props.draftMode, props.siteConfig, siteConfigQuery)

  const slides = []
  if(page.mainCarousel) {
    page.mainCarousel.map((item) => {
      slides.push({
        _id: item._id,
        image: item,
        title: item.title
      });
    })
  }

  return (
    <Layout>
        <SEO title={page.seoTitle} description={page.seoDescription} keywords={page.seoKeywords} />
        <StickyNavbar siteConfig={siteConfig} />
        <main className="w-full bg-background nav-offset py-4 lg:py-8">      
            <div className='mx-10 mb-10'>
              <ModuleList moduleList={page.pageModules} />
            </div>                  
        </main>        
        <Footer siteConfig={siteConfig} />      
    </Layout>
  );
}

